import { Box } from '@mui/material';
import CardContent from '@mui/material/CardContent';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import { constants } from '../../constants';
import useMyMApi from "../../hooks/useMyMApi";
import useValidationRules from '../../hooks/useValidationRules';
import useWebContext from '../../hooks/useWebContext';
import { MyMVariantButton } from '../../ui-elements/MyMButton';
import { MyMLabel } from '../../ui-elements/MyMLabel';
import { MyMProgress } from '../../ui-elements/MyMProgress';
import ValidatableRadio from '../../ui-parts/ValidatableRadio';
import ValidatableTextBox from '../../ui-parts/ValidatableTextBox';
import { mediaQuery, useMediaQuery } from '../../hooks/useMediaQuery';
import { MyMLink } from '../../ui-elements/MyMLink';
import LaunchIcon from '@mui/icons-material/Launch';

/** MyMine Version2.0 TrainingLv2SubLv3画面新規追加
* TrainingLv2SubLv3 Page Content
*/
export const TrainingLv2SubLv3 = () => {
  const screenId = 'MyM320';
  const { controlSettings, messageList } = useWebContext(screenId);
  const apiRequest = useMyMApi(screenId);
  const [isLoading, setIsLoading] = useState(true);
  const [content, setContent] = useState(null);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const { handleSubmit, control, formState } = useForm({
    mode: 'onSubmit',
  })
  const validationRules = useValidationRules();
  const navigate = useNavigate();
  const dateOfRequest = new Date().toLocaleDateString();
  const isPc = useMediaQuery(mediaQuery.pc);
  // 2025.7.7 MyMine Version3.0対応 Add Start
  const [selectedTrainingCategoryValue, setSelectedTrainingCategoryValue] = useState(null);
  // 2025.7.7 MyMine Version3.0対応 Add End

  useEffect(() => {
    setIsLoading(true);

    /**
    * Contents情報取得成功時処理
    * @param {any} result
    */
    const callbackSuccessRequestServiceContents = (result) => {
      if (result === null) {
        // 取得情報がない場合、失敗処理を行う
        callbackFailedRequestServiceContents();
        return;
      }
      setContent(result);
      setIsLoading(false);
    }

    /**
    * Contents情報取得失敗時処理
    */
    const callbackFailedRequestServiceContents = () => {
      setIsLoading(false);
      // エラーページ遷移
      navigate('/MyM999', { state: { message: constants.Message.InvalidRequest } });
    }
    apiRequest.requestJson('api/training/lv2-3', 'GET', callbackSuccessRequestServiceContents, callbackFailedRequestServiceContents);
  }, [])

  const myMSupportButtonStyle = {
    border: '2px solid #777777',
    borderRadius: '10px',
    fontSize: '1rem',
    color: '#000000',
    margin: '10px',
    width: '190px',
    backgroundColor: ' #fff',
    ':hover': {
      backgroundColor: ' #fff',
    }
  };

  const onClickBtnSubmit = (data, e) => {
    if (window.confirm(messageList.MyM_MSG_I_0052)) {
      const callbackSuccess = (result) => {
        setIsLoading(false);
        setIsSubmitted(true);
      }
      const callbackFailed = () => setIsLoading(false);
      //POST
      apiRequest.requestJson('api/training/submit', 'POST', callbackSuccess, callbackFailed, { ...data, DateOfRequest: dateOfRequest });
      setIsLoading(true);
    }
  }

  const onError = (errors, e) => {
    window.alert(messageList.MyM_MSG_E_0003);
  };

  // 2025.7.7 MyMine Version3.0対応 Add Start
  const handleTrainingCategoryChange = (event) => {
    setSelectedTrainingCategoryValue((event.target).value);
  };
  // 2025.7.7 MyMine Version3.0対応 Add Start

  if (content == null)
    return <MyMProgress />

  return (
    <Grid container sx={{ width: isPc ? '1850px' : '100%', justifyContent: 'center' }} className='mt-4'>
      {isLoading && <MyMProgress />}
      <Grid item xs={12} md={isPc ? 8 : 11}>
        {isSubmitted === false ? (
          <CardContent>
            <Grid container sx={{
              '.name-header.name-header': {
                p: 2,
                display: 'flex',
                alignItems: 'center !important',
                borderBottom: 1,
                borderLeft: 1,
                borderRight: 1,
                ':nth-of-type(n+2):not(:last-of-type) ': { backgroundColor: '#F0F0F0' },
              },
              '.input': {
                p: 2,
                display: 'flex',
                alignItems: 'center',
                borderRight: 1,
                borderBottom: 1,
                borderLeft:1
              }
            }}>
              {[
                { label: 'lblDateOfRequest', content: dateOfRequest },
                { label: 'lblCompany', content: 'CompanyName' },
                { label: 'lblSection', content: 'Section' },
                { label: 'lblAddress', content: 'Address' },
                { label: 'lblName', content: 'Name' },
                { label: 'lblEMail', content: 'EMail' },
              ].map((item, index) => (
                <React.Fragment key={index}>
                  <Grid item xs={isPc ? 4 : 4.5} className='name-header' sx={{ borderTop: index === 0 ? 1 : 0 }}>
                    <MyMLabel fontSize={isPc ? '1.5rem' : '1rem'}>
                      {controlSettings.LabelList[item.label]}
                    </MyMLabel>
                  </Grid>
                  <Grid item xs={isPc ? 8 : 7.5} className='input' sx={{ borderTop: index === 0 ? 1 : 0 }}>
                    {typeof item.content === 'string' && item.content !== dateOfRequest ? (
                      <ValidatableTextBox
                        control={control}
                        name={item.content}
                        defaultValue={content?.UserInfo?.[item.content] || ''}
                        formState={formState}
                        maxLength={item.content === 'EMail' ? 256 : item.content === 'Name' ? 101 : 200}
                        rules={{
                          ...validationRules.required(),
                          ...validationRules.maxLength(item.content === 'EMail' ? 256 : item.content === 'Name' ? 101 : 200),
                          ...(item.content === 'EMail' ? validationRules.mailAddress() : {})
                        }}
                        placeholder={controlSettings.LabelList[`${item.label}Placeholder`]}
                      />
                    ) : (
                      <MyMLabel>{item.content}</MyMLabel>
                    )}
                  </Grid>
                </React.Fragment>
              ))}
              <Grid item xs={isPc ? 4 : 4.5} className='name-header'>
                <MyMLabel fontSize={isPc ? '1.5rem' : '1rem'}>
                  {controlSettings.LabelList.lblTrainingCategory}
                </MyMLabel>
              </Grid>
              <Grid item xs={isPc ? 8 : 7.5} className='input'>
                {/*2025.7.7 MyMine Version3.0対応 Modify Start*/}
                <Grid container>
                  <Grid item xs={12}>
                    <ValidatableRadio
                      name="TrainingCategory"
                      control={control}
                      row={isPc}
                      radioList={content.TrainingCategoryList}
                      rules={{ ...validationRules.required() }}
                      formState={formState}
                      onChange={handleTrainingCategoryChange}
                    />
                  </Grid>
                  {selectedTrainingCategoryValue === '3' &&
                    <Grid item xs={12} sx={{ backgroundColor: '#F0F0F0' }}>
                      <Box sx={{ padding: '15px'}}>
                        <MyMLabel fontSize={'1rem'}>{controlSettings.LabelList.lblOperatorTrainingMessage}</MyMLabel>
                        <br />
                        <MyMLink
                          onClick={() => window.open(controlSettings.UrlList.lnkMiningSkillsAustraliaTrainingRequestFormUrl, '_blank')}
                          sx={{ fontSize: '0.9rem', textDecoration: 'underline', textDecorationColor: 'rgba(25, 118, 210, 0.4)' }}
                        >
                          {controlSettings.LabelList.lnkMiningSkillsAustraliaTrainingRequestFormText}
                        </MyMLink>
                        <LaunchIcon sx={{ color: 'gray' }} />
                        <MyMLabel fontSize={'0.8rem'} sx={{ color: 'gray' }}>{controlSettings.LabelList.lblMiningSkillsAustraliaTrainingRequestForm}</MyMLabel>
                      </Box>
                    </Grid>
                  }
                </Grid>
                {/*2025.7.7 MyMine Version3.0対応 Modify End*/}
              </Grid>
              {[
                { label: 'lblTrainingCourse', content: 'TrainingCourse', maxLength: 200 },
                { label: 'lblBackgroundOfTrainingRequest', content: 'BackgroundOfTrainingRequest', maxLength: 1000, multiline: true, rows: 9 },
                { label: isPc ? 'lblDateDuration' : 'lblDateDuration_Mobile', content: 'DateDuration', maxLength: 1000, multiline: true, rows: 8 },
                { label: 'lblNumberOfParticipant', content: 'NumberOfParticipant', maxLength: 200, multiline: !isPc, rows: 4 },
                { label: 'lblLocation', content: 'Location', maxLength: 200 },
              ].map((item, index) => (
                <React.Fragment key={index}>
                  <Grid item xs={12} sx={{ height: '30px', borderBottom: 1, borderLeft: 1, borderRight: 1 }} />
                  <Grid item xs={isPc ? 4 : 4.5} className='name-header'>
                    <MyMLabel fontSize={isPc ? '1.5rem' : (item.label === 'lblBackgroundOfTrainingRequest' ? '0.91rem' : '1rem')}>
                      {controlSettings.LabelList[item.label]}
                    </MyMLabel>
                  </Grid>
                  <Grid item xs={isPc ? 8 : 7.5} className='input'>
                    <ValidatableTextBox
                      control={control}
                      name={item.content}
                      defaultValue=""
                      formState={formState}
                      maxLength={item.maxLength}
                      rules={{
                        ...validationRules.required(),
                        ...validationRules.maxLength(item.maxLength),
                      }}
                      multiline={item.multiline}
                      rows={item.rows}
                      placeholder={controlSettings.LabelList[`${item.label}Placeholder`]}
                    />
                  </Grid>
                </React.Fragment>
              ))}
              <Grid item xs={12} sx={{ height: '30px', borderBottom: 1, borderLeft: 1, borderRight: 1 }} />
              <Grid item xs={12} className='input' sx={{ borderLeft: 1 }}>
                <Grid container>
                  <Grid item xs={12}>
                    <MyMLabel sx={{ display: 'block' }} fontSize={isPc ? '1.5rem' : '1rem'}>
                      {controlSettings.LabelList.lblNoticeAdditionalInformation}
                    </MyMLabel>
                  </Grid>
                  <Grid item xs={12}>
                    <ValidatableTextBox
                      control={control}
                      name="NoticeAdditionalInformation"
                      defaultValue=""
                      formState={formState}
                      maxLength={1000}
                      rules={{
                        ...validationRules.required(),
                        ...validationRules.maxLength(1000),
                      }}
                      multiline={true}
                      rows={8}
                      placeholder={controlSettings.LabelList.lblNoticeAdditionalInformationPlaceholder}
                    />
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={12} className='mt-3'>
                <Stack direction='row' justifyContent="flex-end" spacing={3} className='me-3' sx={{ padding: '0 0 10px 0' }}>
                  <MyMVariantButton
                    sx={myMSupportButtonStyle}
                    fullWidth
                    onClick={handleSubmit(onClickBtnSubmit, onError)}
                    variant='contained'>{controlSettings.LabelList.btnSubmit}</MyMVariantButton>
                  <MyMVariantButton sx={myMSupportButtonStyle} variant='contained' onClick={() => navigate(-1)}>{controlSettings.LabelList.btnBack}</MyMVariantButton>
                </Stack>
              </Grid>
            </Grid>
          </CardContent>
        ) : (
          <CardContent>
            <Box className='text-center'>
              <MyMLabel>{controlSettings.LabelList.lblMessage}</MyMLabel>
              <MyMVariantButton sx={myMSupportButtonStyle} variant='contained' onClick={() => navigate(-1)}>{controlSettings.LabelList.btnBackAfterSubmit}</MyMVariantButton>
            </Box>
          </CardContent>
        )}
      </Grid>
    </Grid>
  );
}

export default TrainingLv2SubLv3;
